<template>
  <section id="section__step2" class="view-container">
    <div class="width-100">
      <p class="font--p-3 mt-5 mb-10">사장님 정보를 알려주세요</p>
      <v-row no-gutters>
        <v-col cols="12">
          <label class="font-size--16">이름</label>
          <v-text-field
            class="mb-3 mt-0"
            hide-details
            v-model="user.name"
            :error="!!invalidMsg.name"
            :rules="rules.name"
          ></v-text-field>
          <ErrorText class="mb-1" :text="invalidMsg.name" />
          <label class="font-size--16">생년월일 <strong>(8자리 ex. 20220825)</strong></label>
          <v-text-field
            type="tel"
            class="mb-3 mt-0"
            hide-details
            v-model="user.birthdate"
            :error="!!invalidMsg.birthdate"
            :rules="rules.birthdate"
            maxlength="8"
          ></v-text-field>
          <ErrorText class="mb-1" :text="invalidMsg.birthdate" />
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <label class="font-size--16">성별</label>
        </v-col>
        <v-col cols="12" style="display: flex">
          <v-col cols="6">
            <v-btn
              depressed
              class="mb-5"
              :color="user.gender === 'male' ? 'primary' : ''"
              style="width: 100%; height: 50px"
              @click="user.gender = 'male'"
              >남자</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn
              depressed
              class="mb-5"
              :color="user.gender === 'female' ? 'primary' : ''"
              style="width: 100%; height: 50px"
              @click="user.gender = 'female'"
              >여자</v-btn
            >
          </v-col>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <p class="font-size--16 text-left mb-0">이메일</p>
          <v-text-field
            hide-details
            class="mb-3 mt-0"
            v-model="user.email"
            :error="!!invalidMsg.email"
            :rules="rules.email"
          ></v-text-field>
          <ErrorText class="mb-1" :text="invalidMsg.email" />
          <p class="font-size--16 text-left mb-0">휴대폰 번호</p>
          <v-text-field
            hide-details
            type="tel"
            class="mb-3 mt-0"
            v-model="user.phone"
            :rules="rules.phone"
            :error="!!invalidMsg.phone"
            v-input-restrict.number
          ></v-text-field>
          <ErrorText class="mb-1" :text="invalidMsg.phone" />
          <p class="font-size--16 text-left mb-0">통신사</p>
          <v-select
            class="mb-3 mt-0"
            v-model="user.mobileCarrier"
            :items="mobileCarriers"
            item-text="label"
            item-value="value"
            :rules="rules.mobileCarrier"
          ></v-select>
        </v-col>
      </v-row>
      <BasicButton @click="next()" :disabled="nextLoading || !isValidAll" :loading="nextLoading">
        다음
      </BasicButton>
    </div>
  </section>
</template>

<script>
import Regex from '@/const/Regex'

import { mapActions, mapState } from 'vuex'
import { simpleClone } from '@/util'

const regExpNotNumeric = new RegExp(Regex.NOT_NUMBERIC.REGEX, 'g')

export default {
  components: {},
  data() {
    return {
      inputBirthdate: null,
      user: {
        birthdate: null,
        mobileCarrier: null,
        name: null,
        phone: null,
        gender: 'male',
        email: null,
      },
      mobileCarriers: [
        {
          label: 'SKT',
          value: 'skt',
        },
        {
          label: 'KT',
          value: 'kt',
        },
        {
          label: 'LG+',
          value: 'lg',
        },
        {
          label: 'SKT 알뜰폰',
          value: 'mvno_skt',
        },
        {
          label: 'KT 알뜰폰',
          value: 'mvno_kt',
        },
        {
          label: 'LG+ 알뜰폰',
          value: 'mvno_lg',
        },
      ],
      nextLoading: false,
      invalidMsg: {
        name: null,
        birthdate: null,
        phone: null,
        email: null,
      },
      rules: {
        name: [
          (value) => !!value || '이름을 입력해주세요.',
          (value) => Regex.NAME.REGEX.test(value) || Regex.NAME.MSG,
        ],
        phone: [
          (value) => !!value || '휴대폰번호를 입력해주세요',
          (value) => Regex.PHONE.REGEX.test(value) || Regex.PHONE.MSG,
        ],
        birthdate: [
          (value) => !!value || '생년월일을 입력해주세요',
          (value) => Regex.BIRTH.REGEX.test(value) || Regex.BIRTH.MSG,
        ],
        email: [
          (value) => !!value || '메일 주소를 입력해주세요.',
          (value) => Regex.EMAIL.REGEX.test(value) || Regex.EMAIL.MSG,
        ],
        mobileCarrier: [(value) => !!value || '통신사를 선택해주세요'],
      },
      nameIsValid: false,
      phoneIsValid: false,
      birthdateIsValid: false,
      genderIsValid: false,
      mobileCarrierIsValid: false,
      emailIsValid: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    kycCdd() {
      return {
        name: this.user.name,
        birthdate: this.user.birthdate,
      }
    },
    updateUser() {
      if (!this.user) {
        return {}
      }
      const birthdate = this.user.birthdate
        ? this.user.birthdate.replace(/^(\d{0,4})(\d{0,2})(\d{0,2})$/g, '$1-$2-$3')
        : null
      return {
        ...this.user,
        birthdate,
      }
    },
    isValidAll() {
      return (
        this.mobileCarrierIsValid === true &&
        this.nameIsValid === true &&
        this.birthdateIsValid === true &&
        this.phoneIsValid === true &&
        this.emailIsValid === true &&
        !this.isgenderValid
      )
    },
    isgenderValid() {
      if (this.user.gender === 'female' || this.user.gender === 'male') {
        return this.genderIsValid === true
      } else {
        return this.genderIsValid === false
      }
    },
  },
  watch: {
    'user': {
      deep: true,
      handler(v) {
        this.user.name = v.name
        this.user.email = v.email
        this.user.phone = v.phone
        this.user.birthdate = v.birthdate
        this.user.mobileCarrier = v.mobileCarrier
      },
    },
    'user.gender': {
      handler(v) {
        if (v === '') {
          this.user.gender = 'male'
        }
      },
    },
    'user.name'(v) {
      this.nameDuplicate(v)
    },
    'user.phone'(v) {
      this.user.phone = v.replace(regExpNotNumeric, '')
      this.phoneDuplicate(v)
    },
    'user.birthdate'(v) {
      this.user.birthdate = v.replace(regExpNotNumeric, '')
      this.birthdateDuplicate(v)
    },
    'user.mobileCarrier'(v) {
      const msg = this.getFormErrMsg('mobileCarrier', v)
      this.mobileCarrierIsValid = msg === null
    },
    'user.email'(v) {
      this.emailValidate(v)
    },
    'isValidAll': {
      immediate: true,
      handler(v) {
        if (v === true) {
          this.$emit('update:user', this.user)
        } else {
          this.$emit('update:user', null)
        }
      },
    },
  },
  async created() {
    this.user = Object.assign(this.user, simpleClone(this.me))
    if (!this.me.phone) {
      this.user.name = null
    }
  },
  methods: {
    ...mapActions('auth', ['getMe', 'updateMe']),
    ...mapActions('kyc', ['addCdd', 'getMobileAuthUrl']),
    ...mapActions('store', ['updateStore']),
    ...mapActions('signup', ['getUserCheckDuplication', 'addUsersSignUpErrorRecords']),
    insertInvalidMsg(type, msg) {
      this.invalidMsg[type] = msg
    },
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]
        const isValid = rule(newVal)
        if (typeof isValid !== 'boolean') {
          msg = isValid
          break
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    nameDuplicate(name) {
      const msg = this.getFormErrMsg('name', name)
      if (msg === null) {
        this.nameIsValid = true
      } else {
        this.nameIsValid = false
      }
    },
    async phoneDuplicate(phone) {
      const msg = this.getFormErrMsg('phone', phone)
      if (msg === null) {
        this.phoneIsValid = true
      } else {
        this.phoneIsValid = false
      }
    },
    birthdateDuplicate(birthdate) {
      const msg = this.getFormErrMsg('birthdate', birthdate)
      if (msg === null) {
        this.birthdateIsValid = true
      } else {
        this.birthdateIsValid = false
      }
    },
    emailValidate(email) {
      const msg = this.getFormErrMsg('email', email)
      if (msg === null) {
        this.emailIsValid = true
      } else {
        this.emailIsValid = false
      }
    },
    async next() {
      try {
        this.nextLoading = true
        const { phone } = this.updateUser
        if (this.me.phone?.replace(/-/gi, '') !== phone.replace(/-/gi, '')) {
          const result = await this.getUserCheckDuplication({
            phone,
          })

          if (result) {
            const { isConfirmed } = await this.$swal.basic.confirm({
              title: '휴대폰 번호 중복',
              html: `입력하신정보가 이미 존재합니다.<br/><br/>
              본인확인을 위해 운영팀에서<br/> 
              유선으로 연락 드릴 예정입니다.<br/>
              02-6925-1788<br/><br/>`,
            })
            if (isConfirmed) {
              await this.addUsersSignUpErrorRecords({
                errors: [
                  {
                    fieldName: 'phone',
                    value: phone,
                    type: 'duplication',
                  },
                ],
              })
              await this.$router.push('/signup/problem')
            }
            return
          }
        }
        await this.updateMe(this.updateUser)
        await this.addCdd(this.kycCdd)
        this.$emit('emitResult', true)
      } finally {
        this.nextLoading = false
      }
    },
  },
}
</script>
